import SettingShops from './SettingShops.vue';

export default SettingShops;
